import React from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'

class ModalBloqueo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tipoBloqueo: 'cliente', // 'cliente' o 'todos'
            loading: false,
            mensaje: null
        }
    }

    handleTipoChange = (e) => {
        this.setState({ tipoBloqueo: e.target.value, mensaje: null })
    }
    
    handleConfirmar = () => {
        const { idUsuario, clientName, usuario } = this.props
        const { tipoBloqueo } = this.state

        if (!idUsuario) {
            this.setState({ mensaje: 'Falta el ID del usuario.' })
            return
        }

        this.setState({ loading: true, mensaje: null })

        let url = ''
        let options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        }

        if (tipoBloqueo === 'cliente') {
            url = `api/personal/${idUsuario}/bloqueo-cliente-dashboard`
            options.body = JSON.stringify({
                client_name: clientName
            })
        } else {
            url = `api/personal/${idUsuario}/bloqueo-cliente-todos-dashboard`
        }

        fetch(url, options)
            .then(res => res.json())
            .then(() => {
                this.setState({
                    loading: false,
                    mensaje: '✅ Bloqueo realizado correctamente.'
                })
            })
            .catch(err => {
                console.error(err)
                this.setState({
                    loading: false,
                    mensaje: '❌ Error al realizar el bloqueo.'
                })
            })
    }
    render() {
        console.log(this.props)
        const { show, onClose, usuario, clientName } = this.props
        const { tipoBloqueo, loading, mensaje } = this.state
        return (
            <Modal show={show} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Bloqueo de Clientes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Selecciona el tipo de bloqueo que deseas realizar para operador(a) {usuario}:</p>
                    <div className="radio">
                        <label>
                            <input
                                type="radio"
                                value="cliente"
                                checked={tipoBloqueo === 'cliente'}
                                onChange={this.handleTipoChange}
                            />
                            &nbsp; Bloquear solo este cliente ({clientName})
                        </label>
                    </div>
                    <div className="radio">
                        <label>
                            <input
                                type="radio"
                                value="todos"
                                checked={tipoBloqueo === 'todos'}
                                onChange={this.handleTipoChange}
                            />
                            &nbsp; Bloquear todos los clientes
                        </label>
                    </div>
                    {mensaje && (
                        <div
                            className={`alert ${
                                mensaje.includes('Error') || mensaje.includes('Falta')
                                    ? 'alert-danger'
                                    : 'alert-success'
                            }`}
                            style={{ marginTop: '15px' }}
                        >
                            {mensaje}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-warning"
                        onClick={this.handleConfirmar}
                        disabled={loading}
                    >
                        {loading ? 'Procesando...' : 'Confirmar Bloqueo'}
                    </button>
                    <button className="btn btn-default" onClick={onClose}>
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }
}
export default ModalBloqueo



// WEBPACK FOOTER //
// ./frontEnd/home/components/ModalBloqueo.jsx